import { typesGlob } from "../types";

const rootArea = "/customers";

export const customersGlob = (baseArea = "") => ({
	self: `${baseArea}${rootArea}`,
	byType: (typeCode: string) => ({ 						
		read: `${baseArea}${rootArea}/${typeCode}/read`,
		create: `${baseArea}${rootArea}/${typeCode}/create`,
		update: `${baseArea}${rootArea}/${typeCode}/update`,
		types: typesGlob(`${baseArea}${rootArea}`)
	})
});